/*
	Name:           Accordion.js
	Description:    Accordion Block script for the theme.
	Version:        1.0.3
	Author:         GH Advertising
*/
(function ($) {
    $(function () {
        $(".c-accordion-block__accordion").each((index, element) => {
            const $accordion = $(element);
            const $headline = $accordion.children(".c-accordion-block__accordion--headline");
            const $panel = $accordion.children(".c-accordion-block__accordion--panel");
            const openByDefault = String($accordion.data("openByDefault")) === "1";

            if (openByDefault) {
                $headline.addClass("active").attr("aria-expanded", "true");
                $panel.show();
                return;
            }

            $headline.removeClass("active").attr("aria-expanded", "false");
            $panel.hide();
        });

        $(".c-accordion-block__accordion > .c-accordion-block__accordion--headline").on("click", function () {
            const $headline = $(this);
            const $panel = $headline.next();
            const isActive = $headline.hasClass("active");

            if (isActive) {
                $headline.removeClass("active");
                $headline.attr("aria-expanded", "false");
                $panel.slideUp();
                return false;
            }

            $headline.addClass("active");
            $headline.attr("aria-expanded", "true");
            $panel.slideDown();
            return false;
        });
    });
})(jQuery);
